var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as actions from '../actions';
var initialState = {
    rehydrated: false,
    loading: false,
    appReady: false
};
/**
 * Storage Sync reducer.
 *
 * This looks a bit different to what would normally happen inside a reducer.
 * The reason for this is the storage sync reducer operates on the entire global
 * state, not a particular subtree.
 *
 * @param state The current state
 * @param action The action that has occurred
 */
export function reducer(reducer) {
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        switch (action.type) {
            case actions.REQUEST_REHYDRATE:
                return Object.assign({}, state, { storageSync: { rehydrated: false, loading: true } });
            case actions.RESPONSE_REHYDRATED:
                return Object.assign({}, state, action.payload, {
                    storageSync: { rehydrated: true, loading: false }
                });
            case actions.REQUEST_SAVE_TO_STORAGE:
                return Object.assign({}, state, { storageSync: __assign({}, state.storageSync, { loading: true }) });
            case actions.RESPONSE_SAVE_TO_STORAGE:
                return Object.assign({}, state, { storageSync: __assign({}, state.storageSync, { loading: false }) });
            case actions.APPLICATION_READY:
                return Object.assign({}, state, {
                    storageSync: __assign({}, state.storageSync, { appReady: true })
                });
            case '@ngrx/store/init':
                return reducer(__assign({}, state, { storageSync: initialState }), action);
            default:
                return Object.assign({}, state, reducer(state, action));
        }
    };
}
export var getRehydrated = function (state) { return (state ? state.rehydrated : false); };
export var isReady = function (state) { return (state ? state.appReady : false); };
